// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to instadrinkpro@gmail.com.

// ----------------------------------------------------------------------

const ar = {
  demo: {
    title: `Arabic`,
    introduction: `لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي بإصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.`,
  },
  docs: {
    hi: `أهلا`,
    description: `تحتاج مساعدة؟ \n الرجاء مراجعة مستنداتنا`,
    documentation: `توثيق`,
  },
  app: `تطبيق`,
  user: `المستعمل`,
  list: `قائمة`,
  edit: `تعديل`,
  shop: `متجر`,
  blog: `مقالات`,
  post: `بريد`,
  mail: `بريد`,
  chat: `دردشة`,
  cards: `البطاقات`,
  posts: `المشاركات`,
  create: `يزيد`,
  kanban: `كانبان`,
  general: `جنرال لواء`,
  banking: `الخدمات المصرفية`,
  booking: `الحجز`,
  profile: `الملف الشخصي`,
  account: `الحساب`,
  product: `المنتوج`,
  invoice: `فاتورة`,
  details: `تفاصيل`,
  checkout: `الدفع`,
  calendar: `التقويم`,
  analytics: `التحليلات`,
  ecommerce: `التجارة الإلكترونية`,
  management: `إدارة`,
  menu_level_1: `مستوى القائمة 1`,
  menu_level_2: `مستوى القائمة 2`,
  menu_level_3: `مستوى القائمة 3`,
  item_disabled: `العنصر معطل`,
  item_label: `تسمية العنصر`,
  item_caption: `عنوان العنصر`,
  description: `وصف`,
  other_cases: `حالات اخرى`,
  item_by_roles: `عنصر حسب الأدوار`,
  only_admin_can_see_this_item: `يمكن للمسؤول فقط رؤية هذا العنصر`,
  'invitation.continuation_title': 'تم إرسال الدعوة بالفعل!',
  'invitation.continuation_body': 'تم إرسال دعوة إلى هذا البريد الإلكتروني بالفعل. يرجى التحقق من صندوق الوارد (والبريد غير المرغوب فيه) واضغط على رابط التحقق.\n\nإذا لم تعثر على البريد الإلكتروني، يمكنك المتابعة عن طريق الضغط على زر <0>إعادة دعوة</0>.',
  'invitation.continuation_use_existing': 'سأتحقق من بريدي الإلكتروني',
  'invitation.continuation_start_new': 'إعادة دعوة',
  cancel_successful: 'تم إلغاء الدعوة',
  cancel_failed: 'تعذر إلغاء الدعوة',
  password_required: 'كلمة المرور مطلوبة',
  password_short: 'كلمة المرور قصيرة جدًا - يجب ألا تقل عن 8 أحرف.',
  password_long: 'كلمة المرور طويلة جدًا - يجب ألا تتجاوز 128 حرفًا.',
  password_alpha: 'يمكن أن تحتوي كلمة المرور على أحرف لاتينية فقط.',
  password_lowercase: 'يجب أن تحتوي كلمة المرور على حرف صغير واحد على الأقل.',
  password_uppercase: 'يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل.',
  password_number: 'يجب أن تحتوي كلمة المرور على رقم واحد على الأقل.',
  password_special: 'يجب أن تحتوي كلمة المرور على رمز خاص واحد على الأقل.',
  password_no_repeat: 'يجب ألا تحتوي كلمة المرور على نفس الحرف ثلاث مرات متتالية.',
  confirm_password_match: 'يجب أن تتطابق كلمتا المرور',
  confirm_password_required: 'تأكيد كلمة المرور مطلوب',
  invitation: {
    status: {
      pending: 'قيد الانتظار',
      accepted: 'مقبولة',
      canceled: 'ملغاة',
      rejected: 'مرفوضة',
      expired: 'منتهية',
    },
  },
};

export default ar;
